import TextSearch from "./textSearch"

export default TextSearch
